import createReactComponent from '../createReactComponent';
var Coffee = createReactComponent('Coffee', [['path', {
  d: 'M18 8h1a4 4 0 010 8h-1',
  key: '10737z'
}], ['path', {
  d: 'M2 8h16v9a4 4 0 01-4 4H6a4 4 0 01-4-4V8z',
  key: 'eeh4wq'
}], ['line', {
  x1: '6',
  y1: '1',
  x2: '6',
  y2: '4',
  key: '1fh3d3'
}], ['line', {
  x1: '10',
  y1: '1',
  x2: '10',
  y2: '4',
  key: '1wlji3'
}], ['line', {
  x1: '14',
  y1: '1',
  x2: '14',
  y2: '4',
  key: '1fzz5q'
}]]);
export default Coffee;